import React, { useState } from 'react';
import LoginButton from './LoginButton';
import Brand from '../Layout/Brand';

export default function LoginScreen({ onSignIn, error, founder = false }) {
  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    setLoading(true);
    try { await onSignIn(); } finally { setLoading(false); }
  };

  return (
    <main className="login-screen">
      <div className="login-glow" />
      <section className="login-panel fade-in">
        <a href="/" className="login-brand" aria-label="LeaveNOW home"><Brand stacked size="lg" /></a>
        <p className="marketing-eyebrow">{founder ? 'Restricted access' : 'Know When to Go.'}</p>
        <h1 className="login-title">{founder ? 'Founder dashboard' : 'Your trips, in one calm place.'}</h1>
        <p className="login-tagline">{founder ? 'Sign in with an authorized founder account.' : 'Arrive calm. Arrive on time.'}</p>
        <LoginButton onClick={handleSignIn} loading={loading} />
        {error && <p className="form-message error" role="alert">{error}</p>}
        <p className="login-note">{founder ? 'Access is controlled by a server-issued admin claim and all support actions are audited.' : 'Live traffic. Smarter departure times.'}</p>
        <a className="login-back" href="/">← Back to LeaveNOW</a>
      </section>
    </main>
  );
}
